import { render, staticRenderFns } from "./AdverseEvent.vue?vue&type=template&id=20a321be&"
import script from "./AdverseEvent.vue?vue&type=script&lang=js&"
export * from "./AdverseEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports